import { Slide } from "@jelly/lesson";
import theory from "../../theory";
import config from "appConfig";

const principle: Slide = {
  descriptionHtml:
    "Click on play sound, select a configuration or choose your own f<sub>1</sub> and f<sub>2</sub> cut-off frequencies and listen to the influence of the bandwidth.",
  theory: theory,
  layout: {
    type: "simple",
    options: {
      components: {
        variant: "blockContainer",
        data: {
          block: {
            type: "iframe",
            options: {
              src: `${config.IFRAMES_REACT_URL}/0407/`,
            },
          },
        },
      },
    },
  },
};

export default principle;
